import { Box, Stack } from '@mui/material';
import { ListSection } from './list-section';

export function ListView() {
  return (
    <Box
      sx={{
        px: '18px',
        pb: '18px',
      }}
    >
      <Stack gap="18px" direction="column">
        <ListSection title="Backlog">Table</ListSection>
        <ListSection title="General">Table</ListSection>
      </Stack>
    </Box>
  );
}
